import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import AddRoomResourceForm from "../AddRoomResourceForm";
import api from "../../../../../../api/room";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const ViewRoomModal = ({
  open,
  handleClose,
  roomInfo,
  resourceId,
  classes
}) => {
  const [formData, updateFormData] = React.useState(null);

  const onClose = () => {
    handleClose();
  };

  useEffect(() => {
    if (resourceId) {
      api
        .getInventoryItem(resourceId)
        .then(({ data }) => updateFormData(data.data));
    }
  }, [resourceId]);

  return (
    formData && (
      <div>
        <Dialog
          onClose={onClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          PaperProps={{
            className: classes.dialog
          }}
        >
          <DialogTitle onClose={onClose}>
            <span>Карточка ресурса</span>
          </DialogTitle>
          <DialogContent>
            <AddRoomResourceForm
              roomInfo={roomInfo}
              onFormChange={() => {}}
              initialData={formData}
              disabled
            />
          </DialogContent>
        </Dialog>
      </div>
    )
  );
};

export default withStyles(styles)(withRouter(ViewRoomModal));
